export enum CashAccountTypeOption {
	Checking = 'Checking',
	Savings = 'Savings',
	MoneyMarket = 'Money Market',
	CD = 'CD',
	Other = 'Other',
}